import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';



export default function FontPicker(props) {

    const classes = useStyles();
    const [showFontList, setShowFontList] = useState(false);
    const wrapperRef = useRef();
    const fonts = [
        'Alegreya',
        'B612',
        'Mulish',
        'Varela',
        'Volkorn',
        'IBM Plex Serif',
        'Crimson Text',
        'Cairo',
        'Playfair Display',
        'Spectral',
        'Roboto',
        'Montserrat',
        'Nunito',
        'Open Sans',
        'Source Sans Pro',
    ]


    const getFontCss = () => {
        return (
            <React.Fragment>
                <link href="https://fonts.googleapis.com/css2?family=Alegreya&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=B612&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Mulish&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Varela&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Vollkorn&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Serif&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Crimson+Text&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Cairo&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Spectral&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Nunito&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap" rel="stylesheet"></link>
            <link href="https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap" rel="stylesheet"></link>

            </React.Fragment>
        );
    }

    useEffect (
        () => {
            window.addEventListener("click", handleClick);
            return ()=>{
                window.removeEventListener("click",handleClick)
            }
        },[wrapperRef]
    )

    const handleClick = (e) => {
        if(!wrapperRef.current.contains(e.target)) {
            setShowFontList(false);
        }
    }

    return (
        <div className={classes.root} ref={wrapperRef}>
            {getFontCss()}
            <div>
                <span className={classes.label}>
                    {props.label}
                </span>
            </div>
            <div onClick={() => setShowFontList(!showFontList)}>
                <span className={classes.selectedFontSpan} style={{ fontFamily: 'Playfair Display' }}>{props.selectedFont}</span>
                <span className="material-icons" >
                    arrow_drop_down
                </span>
            </div>

            {
                showFontList ?
                    <div>
                        {
                            fonts.map(
                                font =>
                                    <div key={font} onClick={() => { props.setSelectedFont(font); setShowFontList(false); }}>
                                        <span key={font} style={{ fontFamily: font, fontSize: '1.2rem', lineHeight:1.5 }}>{font}</span>
                                    </div>
                            )
                        }
                    </div>
                    : null
            }
            <div>

            </div>
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        width:'250px',
    },
    selectedFontSpan: {
        width: '200px',
        display: 'inline-block',
        borderBottom: 'solid 1px gray',
        paddingTop: '10px',
        fontSize: '1.2rem',
    },
    label: {
        fontSize: '0.8rem',
        color: 'rgba(0, 0, 0, 0.54);',
        fontFamily: 'Roboto',
        fontWeight: 400,
    }
});